import { USER_LANGUAGES } from "@/config/enums/user.enum.js";
import homeEn from "@/locales/frontend/en/home.json";
import aboutEn from "@/locales/frontend/en/about.json";
import featuresEn from "@/locales/frontend/en/features.json";
import servicesEn from "@/locales/frontend/en/services.json";
import howItWorksEn from "@/locales/frontend/en/how-it-works.json";
import sponsorsEn from "@/locales/frontend/en/sponsors.json";
import teamEn from "@/locales/frontend/en/team.json";
import pricingEn from "@/locales/frontend/en/pricing.json";
import testimonialsEn from "@/locales/frontend/en/testimonials.json";
import ctaEn from "@/locales/frontend/en/cta.json";
import newsletterEn from "@/locales/frontend/en/news-letter.json";
import faqEn from "@/locales/frontend/en/faq.json";
import footerEn from "@/locales/frontend/en/footer.json";
import registrationEn from "@/locales/frontend/en/registration.json";
import bookingsEn from "@/locales/frontend/en/bookings.json";
import guestsEn from "@/locales/frontend/en/guests.json";
import checkInEn from "@/locales/frontend/en/check-in.json";
import checkOutEn from "@/locales/frontend/en/check-out.json";
import bookingDetailEn from "@/locales/frontend/en/booking-detail.json";
import calendarEn from "@/locales/frontend/en/calendar.json";
import accessMatrixEn from "@/locales/frontend/en/access-matrix.json";
import componentEn from "@/locales/frontend/en/component.json";
import organizationEn from "@/locales/frontend/en/organization.json";
import roleEn from "@/locales/frontend/en/role.json";
import profileEn from "@/locales/frontend/en/profile.json";
import locationEn from "@/locales/frontend/en/location.json";
import registrationRequestEn from "@/locales/frontend/en/registration-request.json";
import registrationReviewEn from "@/locales/frontend/en/registration-review.json";
import forgotPasswordEn from "@/locales/frontend/en/forgot-password.json";
import resetPasswordEn from "@/locales/frontend/en/reset-password.json";
import userManagementEn from "@/locales/frontend/en/user-management.json";
import sidebarManagementEn from "@/locales/frontend/en/sidebar-management.json";
import hotelInfoEn from "@/locales/frontend/en/hotel-info.json";
import routeEn from "@/locales/frontend/en/route.json";
import authEn from "@/locales/frontend/en/auth.json";
import reviewsEn from "@/locales/frontend/en/reviews.json";
import enrichedReviewsEn from "@/locales/frontend/en/enriched-reviews.json";
import summariesEn from "@/locales/frontend/en/summaries.json";
import maintenanceEn from "@/locales/frontend/en/maintenance.json";
import grievancesEn from "@/locales/frontend/en/grievances.json";
import cancellationPolicyEn from "@/locales/frontend/en/cancellation-policy.json";
import earlyDepartureEn from "@/locales/frontend/en/early-departure.json";
import pricingCapsEn from "@/locales/frontend/en/pricing-caps.json";
import ratePlansEn from "@/locales/frontend/en/rate-plans.json";
import pricingRulesEn from "@/locales/frontend/en/pricing-rules.json";
import boardPlanEn from "@/locales/frontend/en/board-plan.json";
import breadcrumbEn from "@/locales/frontend/en/breadcrumb.json";
import navUserEn from "@/locales/frontend/en/nav-user.json";
import housekeepingEn from "@/locales/frontend/en/housekeeping.json";
import masterDataEn from "@/locales/frontend/en/master-data.json";
import subscriptionEn from "@/locales/frontend/en/subscription.json";
import staffEn from "@/locales/frontend/en/staff.json";
import propertyEn from "@/locales/frontend/en/property.json";
import subscriptionPlansEn from "@/locales/frontend/en/subscription-plans.json";
import subscriptionsEn from "@/locales/frontend/en/subscriptions.json";
import notificationSettingsEn from "@/locales/frontend/en/notification-settings.json";
import zatcaEn from "@/locales/frontend/en/zatca.json";
import checkoutEn from "@/locales/frontend/en/checkout.json";
import commonEn from "@/locales/frontend/en/common.json";
import specialRequestsEn from "@/locales/frontend/en/special-requests.json";
import notificationTemplatesEn from "@/locales/frontend/en/notification-templates.json";
import faqManagementEn from "@/locales/frontend/en/faq-management.json";
import propertyPolicyEn from "@/locales/frontend/en/property-policy.json";
import hotelOwnerRegistrationEn from "@/locales/frontend/en/hotel-owner-registration.json";
import propertyAddonsEn from "@/locales/frontend/en/property-addons.json";
import nightAuditEn from "@/locales/frontend/en/night-audit.json";
import foliosEn from "@/locales/frontend/en/folios.json";
import invoiceEn from "@/locales/frontend/en/invoice.json";
import paymentTypesEn from "@/locales/frontend/en/payment-types.json";
import complianceEn from "@/locales/frontend/en/compliance.json";
import propertyPageEn from "@/locales/frontend/en/property-page.json";
import inspectionEn from "@/locales/frontend/en/inspection.json";
import consumableItemsEn from "@/locales/frontend/en/consumableItems.json";
import parLevelsEn from "@/locales/frontend/en/parLevels.json";
import roomInventoryEn from "@/locales/frontend/en/roomInventory.json";
import sidebarEn from "@/locales/frontend/en/sidebar.json";
import settingsEn from "@/locales/frontend/en/settings.json";

import nightAuditAr from "@/locales/frontend/ar/night-audit.json";
import foliosAr from "@/locales/frontend/ar/folios.json";
import invoiceAr from "@/locales/frontend/ar/invoice.json";
import homeAr from "@/locales/frontend/ar/home.json";
import aboutAr from "@/locales/frontend/ar/about.json";
import featuresAr from "@/locales/frontend/ar/features.json";
import servicesAr from "@/locales/frontend/ar/services.json";
import howItWorksAr from "@/locales/frontend/ar/how-it-works.json";
import sponsorsAr from "@/locales/frontend/ar/sponsors.json";
import teamAr from "@/locales/frontend/ar/team.json";
import pricingAr from "@/locales/frontend/ar/pricing.json";
import testimonialsAr from "@/locales/frontend/ar/testimonials.json";
import ctaAr from "@/locales/frontend/ar/cta.json";
import newsletterAr from "@/locales/frontend/ar/news-letter.json";
import faqAr from "@/locales/frontend/ar/faq.json";
import footerAr from "@/locales/frontend/ar/footer.json";
import registrationAr from "@/locales/frontend/ar/registration.json";
import bookingsAr from "@/locales/frontend/ar/bookings.json";
import guestsAr from "@/locales/frontend/ar/guests.json";
import checkInAr from "@/locales/frontend/ar/check-in.json";
import checkOutAr from "@/locales/frontend/ar/check-out.json";
import bookingDetailAr from "@/locales/frontend/ar/booking-detail.json";
import calendarAr from "@/locales/frontend/ar/calendar.json";
import accessMatrixAr from "@/locales/frontend/ar/access-matrix.json";
import componentAr from "@/locales/frontend/ar/component.json";
import organizationAr from "@/locales/frontend/ar/organization.json";
import roleAr from "@/locales/frontend/ar/role.json";
import profileAr from "@/locales/frontend/ar/profile.json";
import locationAr from "@/locales/frontend/ar/location.json";
import registrationRequestAr from "@/locales/frontend/ar/registration-request.json";
import registrationReviewAr from "@/locales/frontend/ar/registration-review.json";
import forgotPasswordAr from "@/locales/frontend/ar/forgot-password.json";
import resetPasswordAr from "@/locales/frontend/ar/reset-password.json";
import userManagementAr from "@/locales/frontend/ar/user-management.json";
import sidebarManagementAr from "@/locales/frontend/ar/sidebar-management.json";
import hotelInfoAr from "@/locales/frontend/ar/hotel-info.json";
import routeAr from "@/locales/frontend/ar/route.json";
import authAr from "@/locales/frontend/ar/auth.json";
import reviewsAr from "@/locales/frontend/ar/reviews.json";
import enrichedReviewsAr from "@/locales/frontend/ar/enriched-reviews.json";
import summariesAr from "@/locales/frontend/ar/summaries.json";
import maintenanceAr from "@/locales/frontend/ar/maintenance.json";
import grievancesAr from "@/locales/frontend/ar/grievances.json";
import cancellationPolicyAr from "@/locales/frontend/ar/cancellation-policy.json";
import earlyDepartureAr from "@/locales/frontend/ar/early-departure.json";
import pricingCapsAr from "@/locales/frontend/ar/pricing-caps.json";
import ratePlansAr from "@/locales/frontend/ar/rate-plans.json";
import pricingRulesAr from "@/locales/frontend/ar/pricing-rules.json";
import boardPlanAr from "@/locales/frontend/ar/board-plan.json";
import breadcrumbAr from "@/locales/frontend/ar/breadcrumb.json";
import navUserAr from "@/locales/frontend/ar/nav-user.json";
import housekeepingAr from "@/locales/frontend/ar/housekeeping.json";
import masterDataAr from "@/locales/frontend/ar/master-data.json";
import subscriptionAr from "@/locales/frontend/ar/subscription.json";
import staffAr from "@/locales/frontend/ar/staff.json";
import propertyAr from "@/locales/frontend/ar/property.json";
import subscriptionPlansAr from "@/locales/frontend/ar/subscription-plans.json";
import subscriptionsAr from "@/locales/frontend/ar/subscriptions.json";
import notificationSettingsAr from "@/locales/frontend/ar/notification-settings.json";
import hotelOwnerRegistrationAr from "@/locales/frontend/ar/hotel-owner-registration.json";
import zatcaAr from "@/locales/frontend/ar/zatca.json";
import propertyAddonsAr from "@/locales/frontend/ar/property-addons.json";
import checkoutAr from "@/locales/frontend/ar/checkout.json";
import commonAr from "@/locales/frontend/ar/common.json";
import specialRequestsAr from "@/locales/frontend/ar/special-requests.json";
import notificationTemplatesAr from "@/locales/frontend/ar/notification-templates.json";
import faqManagementAr from "@/locales/frontend/ar/faq-management.json";
import propertyPolicyAr from "@/locales/frontend/ar/property-policy.json";
import paymentTypesAr from "@/locales/frontend/ar/payment-types.json";
import complianceAr from "@/locales/frontend/ar/compliance.json";
import propertyPageAr from "@/locales/frontend/ar/property-page.json";
import inspectionAr from "@/locales/frontend/ar/inspection.json";
import consumableItemsAr from "@/locales/frontend/ar/consumableItems.json";
import parLevelsAr from "@/locales/frontend/ar/parLevels.json";
import roomInventoryAr from "@/locales/frontend/ar/roomInventory.json";
import sidebarAr from "@/locales/frontend/ar/sidebar.json";
import settingsAr from "@/locales/frontend/ar/settings.json";

const getLanguage = () => {
  if (typeof window !== "undefined") {
    return localStorage.getItem("language") || USER_LANGUAGES.ENGLISH;
  }
  return USER_LANGUAGES.ENGLISH;
};

const translations = {
  en: {
    home: homeEn,
    about: aboutEn,
    features: featuresEn,
    services: servicesEn,
    howItWorks: howItWorksEn,
    sponsors: sponsorsEn,
    team: teamEn,
    pricing: pricingEn,
    testimonials: testimonialsEn,
    cta: ctaEn,
    newsletter: newsletterEn,
    faq: faqEn,
    footer: footerEn,
    registration: registrationEn,
    forgotPassword: forgotPasswordEn,
    resetPassword: resetPasswordEn,
    userManagement: userManagementEn,
    sidebarManagement: sidebarManagementEn,
    hotelInfo: hotelInfoEn,
    reviews: reviewsEn,
    enrichedReviews: enrichedReviewsEn,
    summaries: summariesEn,
    bookings: bookingsEn,
    guests: guestsEn,
    checkIn: checkInEn,
    checkOut: checkOutEn,
    bookingDetail: bookingDetailEn,
    calendar: calendarEn,
    accessMatrix: accessMatrixEn,
    component: componentEn,
    organization: organizationEn,
    role: roleEn,
    profile: profileEn,
    location: locationEn,
    registrationRequest: registrationRequestEn,
    registrationReview: registrationReviewEn,
    route: routeEn,
    auth: authEn,
    maintenance: maintenanceEn,
    grievances: grievancesEn,
    cancellationPolicy: cancellationPolicyEn,
    earlyDeparture: earlyDepartureEn,
    pricingCaps: pricingCapsEn,
    ratePlans: ratePlansEn,
    pricingRules: pricingRulesEn,
    boardPlan: boardPlanEn,
    breadcrumb: breadcrumbEn,
    navUser: navUserEn,
    housekeeping: housekeepingEn,
    masterData: masterDataEn,
    subscription: subscriptionEn,
    staff: staffEn,
    property: propertyEn,
    subscriptionPlans: subscriptionPlansEn,
    subscriptions: subscriptionsEn,
    notificationSettings: notificationSettingsEn,
    hotelOwnerRegistration: hotelOwnerRegistrationEn,
    zatca: zatcaEn,
    propertyAddons: propertyAddonsEn,
    checkout: checkoutEn,
    common: commonEn,
    specialRequests: specialRequestsEn,
    notificationTemplates: notificationTemplatesEn,
    nightAudit: nightAuditEn,
    folios: foliosEn,
    faqManagement: faqManagementEn,
    propertyPolicy: propertyPolicyEn,
    invoice: invoiceEn,
    paymentTypes: paymentTypesEn,
    compliance: complianceEn,
    propertyPage: propertyPageEn,
    inspection: inspectionEn,
    consumableItems: consumableItemsEn,
    parLevels: parLevelsEn,
    roomInventory: roomInventoryEn,
    sidebar: sidebarEn,
    settings: settingsEn,
  },
  ar: {
    home: homeAr,
    about: aboutAr,
    features: featuresAr,
    services: servicesAr,
    howItWorks: howItWorksAr,
    sponsors: sponsorsAr,
    team: teamAr,
    pricing: pricingAr,
    testimonials: testimonialsAr,
    cta: ctaAr,
    newsletter: newsletterAr,
    faq: faqAr,
    footer: footerAr,
    registration: registrationAr,
    forgotPassword: forgotPasswordAr,
    resetPassword: resetPasswordAr,
    userManagement: userManagementAr,
    sidebarManagement: sidebarManagementAr,
    hotelInfo: hotelInfoAr,
    reviews: reviewsAr,
    enrichedReviews: enrichedReviewsAr,
    summaries: summariesAr,
    bookings: bookingsAr,
    guests: guestsAr,
    checkIn: checkInAr,
    checkOut: checkOutAr,
    bookingDetail: bookingDetailAr,
    calendar: calendarAr,
    accessMatrix: accessMatrixAr,
    component: componentAr,
    organization: organizationAr,
    role: roleAr,
    profile: profileAr,
    location: locationAr,
    registrationRequest: registrationRequestAr,
    registrationReview: registrationReviewAr,
    route: routeAr,
    auth: authAr,
    maintenance: maintenanceAr,
    grievances: grievancesAr,
    cancellationPolicy: cancellationPolicyAr,
    earlyDeparture: earlyDepartureAr,
    pricingCaps: pricingCapsAr,
    ratePlans: ratePlansAr,
    pricingRules: pricingRulesAr,
    boardPlan: boardPlanAr,
    breadcrumb: breadcrumbAr,
    navUser: navUserAr,
    housekeeping: housekeepingAr,
    masterData: masterDataAr,
    subscription: subscriptionAr,
    staff: staffAr,
    property: propertyAr,
    subscriptionPlans: subscriptionPlansAr,
    subscriptions: subscriptionsAr,
    notificationSettings: notificationSettingsAr,
    hotelOwnerRegistration: hotelOwnerRegistrationAr,
    zatca: zatcaAr,
    propertyAddons: propertyAddonsAr,
    checkout: checkoutAr,
    common: commonAr,
    specialRequests: specialRequestsAr,
    notificationTemplates: notificationTemplatesAr,
    nightAudit: nightAuditAr,
    folios: foliosAr,
    faqManagement: faqManagementAr,
    propertyPolicy: propertyPolicyAr,
    invoice: invoiceAr,
    paymentTypes: paymentTypesAr,
    compliance: complianceAr,
    propertyPage: propertyPageAr,
    inspection: inspectionAr,
    consumableItems: consumableItemsAr,
    parLevels: parLevelsAr,
    roomInventory: roomInventoryAr,
    sidebar: sidebarAr,
    settings: settingsAr,
  },
};

export const msg = (key, lang = null) => {
  if (!key) return "";

  const currentLang = lang || getLanguage();
  const language =
    currentLang === USER_LANGUAGES.ARABIC
      ? USER_LANGUAGES.ARABIC
      : USER_LANGUAGES.ENGLISH;

  const fileName = key.split(".")[0];
  const keyPath = key.split(".").slice(1);

  try {
    const langTranslations = translations[language];
    if (!langTranslations) {
      return msg(key, "en");
    }

    const data = langTranslations[fileName];
    if (!data) {
      if (language !== "en") {
        return msg(key, "en");
      }
      return key;
    }

    let unwrappedData = data;
    if (data && typeof data === "object" && fileName in data) {
      unwrappedData = data[fileName];
    }

    let value = unwrappedData;
    for (const part of keyPath) {
      if (value && typeof value === "object" && part in value) {
        value = value[part];
      } else {
        if (language !== "en") {
          return msg(key, "en");
        }
        return key;
      }
    }

    return value || key;
  } catch (error) {
    if (language !== "en") {
      return msg(key, "en");
    }
    return key;
  }
};

export const setLanguage = (lang) => {
  if (typeof window !== "undefined") {
    localStorage.setItem("language", lang);
    window.dispatchEvent(new CustomEvent("languagechange", { detail: lang }));
  }
};

export const getCurrentLanguage = () => {
  return getLanguage();
};

/**
 * Turn API multilingual fields ({ en, ar }) or plain strings into a single display string.
 * @param {unknown} value
 * @param {string} [locale] – `"en"` | `"ar"`; defaults to current UI language from localStorage
 */
export function resolveLocalizedText(value, locale = null) {
  const lang = locale || getLanguage();
  if (value == null || value === "") return "";
  if (typeof value === "string") return value;
  if (typeof value === "object") {
    const o = value;
    if (Object.prototype.hasOwnProperty.call(o, "en") || Object.prototype.hasOwnProperty.call(o, "ar")) {
      const v = o[lang] ?? o.en ?? o.ar;
      return v != null && v !== "" ? String(v) : "";
    }
  }
  return String(value);
}
